import React,{Children, useState} from 'react';

const initialState={
    type:"",
    src:"",
    backgroundColor:"white", 
    activePanel:"Activity",
}

 
const videoData ={
  currentFolderName:null,
  currentFolderId:null,
  currentGalleryName:null,
  currentFileName:null,
  userData:[]
}
export const Context = React.createContext();

const DesignContext = (props) => 
{
   // console.log("INITIAL STATE === ",initialState)
    const [state,setState]=useState(initialState);
   ;
    const [videoState,setVideoState]=useState(videoData);
    return (
      <Context.Provider value={{value:[state,setState],appData:[videoState,setVideoState]}}>{props.children}</Context.Provider>
    )
}

export default DesignContext;
